import { industryType } from "utils/helpers";

const LogoSection = () => (
  <div style={{ fontWeight: "bold" }}>
    {industryType("auto") ? "Dealer Logo(s)" : "Account-Specific Logo"}
  </div>
);

export default LogoSection;
